<template>
  <z-dialogo ref="dialogo" titulo="Caixa Mensal" :dividers="true" largura="500px" persistent>
    <template #texto>
      <v-row dense>
        <v-col cols="12" sm="6">
          <z-select :items="meses" label="Mês" persistent-placeholder v-model="filtro.mes"></z-select>
        </v-col>
        <v-col cols="12" sm="6">
          <z-select :items="anos" label="Ano" persistent-placeholder v-model="filtro.ano"></z-select>
        </v-col>
      </v-row>
    </template>

    <template #actions_right>
      <v-btn text @click="$refs.dialogo.fechar()">
        Cancelar
      </v-btn>
      <v-btn text color="primary" @click="imprimir">
        <v-icon left>mdi-printer</v-icon>
        Imprimir
      </v-btn>
    </template>
  </z-dialogo>
</template>

<script>
// import { MESES } from '@/app/globals';

export default {
  name: 'MesesAnos',

  props: {
    relatorio: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      aberto: false,
      filtro: {
        mes: parseInt(this.$dayjs().format('M')),
        ano: this.$dayjs().format('YYYY'),
      },
      meses: this.$globals.MESES,
    };
  },

  computed: {
    anos() {
      let anos = [];
      for (let ano = 2015; ano <= this.$dayjs().format('YYYY'); ano++) {
        anos.push(ano.toString());
      }
      return anos.reverse();
    },
  },

  methods: {
    abrir() {
      this.$refs.dialogo.abrir();
    },

    fechar() {
      this.$refs.dialogo.fechar();
    },

    imprimir() {
      this.$emit('imprimir', this.filtro);
    },
  },
};
</script>

<style scoped></style>
